export const LOGIN_URL="systems/user/login"
export const GET_CURRENT_ROLE="/systems/current-role"
export const ADMIN_LOGIN_URL="/administrative/login"
export const FORGOT_PASSWORD_URL="/systems/user-forget-password-request"
export const ADMIN_FORGOT_PASSWORD_URL="/administrative/admin-forget-password-request"
export const VALIDATE_OTP="/systems/user-validate-password"
export const ADMIN_VALIDATE_OTP="/administrative/admin-validate-otp"
export const RESET_PASSWORD="/systems/user-reset-password"
export const ADMIN_RESET_PASSWORD="/administrative/admin-reset-password"
export const CHECK_IN="/attendence/user-attendance-checkIn"
export const CHECK_OUT="/attendence/user-attendance-checkout"
export const EMPLOYEE_PROFILE=""
export const CHEACK_IN_OUT_HISTORY="/attendence/users-attendance-list"
export const ADMIN_CHEACK_IN_OUT_HISTORY="/systems/attendance/current-month-employee-attendance-list"
export const EMPLOYEE_LIST="/dashboard/get-all-employee-list"
export const HOLIDAY_CALENDER_LIST="/systems/holiday/get-all-holiday-calender"
export const VISITORLIST="/attendence/visitor/admin-visitors-list"
export const GET_EXPORT_EMPLOYEE_LIST="/dashboard/export-get-all-employee-list"
export const EMPLOYEE_DETAIL="/dashboard/get-employee-by-id/"
export const EDIT_EMPLOYEE_DETAIL="/systems/employee/update-employee-admin/"
export const EDIT_ROLE = "systems/role/update-user-role"
// export const EDIT_EMPLOYEE_DETAIL="/dashboard/update-employee_admin/"
// export const EDIT_EMPLOYEE_DETAIL="dashboard/update-employee-admin/"
export const DELETE_EMPLOYEE="dashboard/delete-employee/"
export const DELETE_HOLIDAY="/systems/holiday/delete-holiday-record"
export const GET_HOLIDAY_ROW_DATA="/systems/holiday/get-holiday-calender"
export const UPDATE_HOLIDAY_RECORD="/systems/holiday/update-holiday-record"
export const ADD_EMPLOYEE_DETAIL="/systems/register-new-user"
export const BULK_ADD_EMPLOYEE_DETAIL="/systems/bulk-user-register"
export const BULK_ADD_HOLIDAY="/systems/holiday/bulk-insert"
export const GET_ALL_ROLES="/systems/role/all-roles"
export const GET_ALL_DEPARTMENT="/systems/department/all-department"
export const CRETATE_DEPARTMENT="/systems/department/add-department"
export const UPDATE_DEPARTMENT="/systems/department/update-department"
export const DELETE_DEPARTMENT="/systems/department/delete-department"
export const GET_ALL_DESIGNATION="/systems/designation/all-designation"
export const CRETATE_DESIGNATION="/systems/designation/add-designation"
export const UPDATE_DESIGNATION="/systems/designation/update-designation"
export const DELETE_DESIGNATION="/systems/designation/delete-designation"
export const GET_ALL_RESOURCES="/systems/resource/all-resource"
export const GET_ALL_ACTIONS="systems/action/all-actions"
export const ADD_NEW_ROLE="/systems/role/add-role"
export const GET_ALL_ROLESLIST="/systems/role/all-roles"
export const DELETE_Role="/systems/role/delete-role/"
export const UPDATE_ROLE="/systems/role/update-role/"
export const COMPANYACTION="/administrative/company/action-against-company"
// export const SIGN_IN_USER_RESET_PASSWORD="/systems/sign-in-user-reset-password"
export const SIGN_IN_USER_RESET_PASSWORD="/dashboard/sign-in-user-reset-password"
export const UPDATE_USER="/dashboard/update-employee"
export const GET_SINGLE_EMPLOYEE_DETAILS="/dashboard/get-employee-data"
export const GET_TODAY_EMPLOYEES_ATTENDACE_LIST="/systems/attendance/current-employee-attendance-list"
export const RESET_EMPLOYEE_ATTENDENCE="/systems/attendance/admin-side-checkinout-reset"
export const DEVICE_AUTH_REQUEST_LIST="/desktop/deviceauthrequests"
export const DEVICE_AUTH_REQUEST_STATUS_CHANGE="/desktop/deviceauthrequeststatuschange"
export const GET_ALL_COMPANY_CONFIG="/systems/attendance/admin-get-company-configuration"
export const EDIT_COMPANY_CONFIG="/systems/attendance/admin-update-company-configuration"
export const GET_CONFIG="/attendence/get-company-configuration-web"
export const GET_COMPLIENCE_REPORT="/systems/attendance/attendance-complaince-report"

export const GET_FILTRED_EMPLOYEE_LIST="/systems/attendance/filter-report"
export const GET_PROJECT_LABEL="/attendence/project-label/get-all-project-labels"
export const GET_PROJECT_TIMESHEET="/attendence/project-label/get-time-sheet-report"
export const CHECK_IN_ABCENT_EMPLOYEE_LIST="/attendence/absent-employee-list"
export const Add_EMPLOYEE_CHECKIN="/attendence/add-absent-employee-attendance"
export const EMPLOYEE_REQUEST_CHECKIN="/attendence/requests/add-attendance-request"
export const CONTACT_US="/systems/contact-us"

export const COMPANYREGISTER="/front/company-register"
// export const COMPANYREGISTER="/administrative/company/company-form-details"
export const COMAPANY_LIST="/administrative/company/get-all-companies"
export const COMPANY_STATISTICS="/administrative/company/get-company-statistics"
export const COMPANY_USAGE_STATS="/administrative/company/get-company-usage-stats"
export const COMAPANY_DETAILS="/administrative/company/get-company-details/"
export const UPDATE_COMAPANY_DETAILS="/administrative/company/update-company-details/"
export const ADD_COMPANY_REQUEST_FORM="/administrative/company/register-company"

export const GET_DASHBOARD_EMPLOYEE_STATUS="/dashboard/admin/get-dashboard-count-status"
export const PRESENT_ABSENT_LIST="dashboard/admin/get-dashboard-present-absent-list"
export const PRESENT_ABSENT_COUNT="dashboard/admin/get-dashboard-present-absent-count"
export const YEARLY_AVG="/dashboard/admin/get-dashboard-yearly-average"
export const MONTHLY_AVG="/dashboard/admin/get-dashboard-monthly-average"
export const DAILY_AVG="/dashboard/admin/get-dashboard-daily-average"
export const ATTENDANCE_TREND="/dashboard/admin/get-attendance-trend"
export const ACHIVERS_LIST="/dashboard/admin/get-dashboard-achivers"
export const ON_APPROVED_LEAVE_COUNT="/dashboard/admin/get-dashboard-on-approved-leave-count"
export const PENDING_APPROVAL_COUNTS="/dashboard/admin/get-dashboard-pending-approval-counts"
export const PENDING_APPROVAL_QUEUE="/dashboard/admin/get-dashboard-pending-approval-queue"
export const ACTIVE_IDLE_TIME="/dashboard/admin/get-dashboard-active-idle-time"
export const SUPERVISOR_DETAILS="/leaverequest/get-supervisors"
export const GET_ALL_LEAVE_REQUEST_LIST_SUPERVISOR = "/leaverequest/get-employee-leave-request-list-supervisor"
export const GET_LEAVE_REPORT="/leave/employe-leave-list"
export const GET_EMPLOYEE_LEAVE_REPORT="/leave/employe-leave-list-details"
export const GET_EMPLOYEE_REQUEST_LIST="/attendence/requests/employee-get-all-requests" 
export const GET_ADMIN_EMPLOYEE_REQUEST_LIST="/attendence/requests/get-all-requests" 
export const EMPLOYEE_CHECKIN_OUT_CANCEL_REQUEST="/attendence/requests/delete-attendance-request" 
export const ADMIN_CHECKIN_OUT_CANCEL_REQUEST="/attendence/requests/admin-update-attendance-request" 
export const GET_TODAY_ATTENDACE_REPORT="/attendence/get-attendance-by-login-user"
export const GET_EDIT_REQUEST_CHECK_INOUT="/attendence/requests/get-request"
export const UPDATE_EDIT_CHECKIN_OUT_REQUEST_DATA="/attendence/requests/update-attendance-request"
export const UPDATE_LEAVE_REPORT_STATUS="/leave/add-employe-leave-exception"
// export const UPDATE_LEAVE_REPORT_STATUS="/leave/employe-leave-approve"
export const GENERATE_LEAVE_MANUAL="/systems/attendance/add-leave-record"
export const GET_EPLOYEE_LEAVE_LIST="/dashboard/employee-leaves"

export const LEAVE_CATEGORY_TYPE="/leavemanagementcommon/dropdown-leave-category-type"
export const ACCRUALPERIOD="/leavemanagementcommon/dropdown-accrual-period-type"
export const ACCRUAL_TIME="/leavemanagementcommon/dropdown-accrual-time-type"
export const ACCRUAL_RESET="/leavemanagementcommon/dropdown-accrual-reset"
export const ADD_LEAVE_TYPE="/leavetype/add-leave-type"
export const LEAVE_LIST="/leavetype/get-leave-type-list"
export const UPDATE_LEAVE_TYPE="/leavetype/update-leave-type"
export const DELETE_LEAVE_TYPE="/leavetype/delete-leave-type"
export const GET_ALL_LEAVE_CONFIG="/leavemanagementsetting/get-leave-management-config"
export const GET_ALL_LEAVE_CYCLE_DATA="/leavemanagementcommon/dropdown-leave-cycle"
export const UPDATE_LEAVE_CONFIG="/leavemanagementsetting/update-leave-management-config"
export const IMPORT_LEAVE_ADJUSTMENT_LIST="/leaveadjustment/get-export-leave-adjustment-employee-list"
export const LEAVE_ADJUSTMENT_BULK_UPLOAD="/leaveadjustment/import-employee-leave-adjustment"
export const EMPLOYEE_LEAVE_ADJUSTMENT_LIST="/leaveadjustment/get-leave-adjustment-employee-list"
export const UPDATE_EMPLOYEE_LEAVE_ADJUSTMENT_LIST="/leaveadjustment/update-employee-leave-adjustment"
export const LEAVE_TYPE="/leavemanagementcommon/dropdown-leave-type"
export const EMPLOYEE_MONTHLY_ACHIVERS="/dashboard/admin/get-employee-dashboard-achivers"


// employee activity apis end points
export const GET_EMPLOYEE_ACTIVITY_LIST="/activitytracker/employee-activity-list"
export const GET_EMPLOYEE_ACTIVITY_IMAGES_LIST="/activitytracker/employee-activity-screenshot-list"
export const GET_EMPLOYEE_ACTIVITY_APP_LIST="/activitytracker/activity-review-app-list"
export const CHANGE_APP_REVIEW_STATUS="/activitytracker/review-app-status-change"
export const ACTIVITY_EMPLOYEE_LIST="/activitytracker/dropdown-employee-list-activity"
export const ACTIVITY_EMPLOYEE_APP_DURATIONS="/activitytracker/employee-activity-app-durations"
export const ACTIVITY_EMPLOYEE_APP_USES="/activitytracker/employee-activity-app-uses"
export const GET_EMPLOYEE_ACTIVITY_DATA="/activitytracker/employee-activity-log-data"
export const ZIP_EMPLOYEE_SCREENSHOT="/activitytracker/employee-activity-export-all-screenshots"


// device Approval
export const EMPLOYEE_DEVICE_AUTH_REVOKE="/desktop/deviceauthrevoke"
export const APP_HEARTBEAT_EMPLOYEE_LIST="/systems/attendance/appheartbeatlist/desktop"
export const GET_USER_ACTIVITY_TRACKKER_CONFIG="/activitytrackermanagementsetting/get-activity-tracker-management-config"
export const PUT_USER_ACTIVITY_TRACKKER_CONFIG="/activitytrackermanagementsetting/update-activity-tracker-management-config"


// apk vertsion Apis
export const GET_APP_VERSION_AND_PATH="/application/versionlist/mobile"
export const GET_DESKTOP_APP_VERSION_AND_PATH="/application/versionlist/desktop"
export const GET_PRICING_PLANS="/front/plan-list"
export const GET_PLAN_FILTER_OPTIONS="/administrative/company/get-plan-filter-options"


//company plan
export const GET_COMPANY_PLAN="/administrative/company/get-company-plan-details"
export const UPDATE_COMAPANY_PLAN_DETAILS="/administrative/company/update-company-plan-details"
export const GET_VERIFY_EMAIL="/front/verify-email"


export const UPLOAD_PROFILE_IMAGE="/dashboard/upload-profile-picture"
export const GET_USER_PROFILE_PICTURE="/dashboard/get-user-profile-picture"
export const DELETE_USER_PROFILE_PICTURE="/dashboard/delete-user-profile-picture"
export const GET_USET_FACE_DETECT="/dashboard/user-face-detect"

export const UPDATE_COMAPANY_MODULES="/administrative/company/update-company-modules/"
export const UPDATE_COMPANY_PLAN="/administrative/company/update-company-plan"
export const GET_COMPANY_PLAN_DETAILS="/administrative/company/get-company-plan-details/"



// -------------- employee management -----------------

export const GET_EMPLOYEE_DOCUMENTS="/systems/management/document"
export const POST_EMPLOYEE_DOCUMENTS="/systems/management/document"
export const PUT_EMPLOYEE_DOCUMENTS="/systems/management/document"
export const DELETE_EMPLOYEE_DOCUMENTS="/systems/management/document"
export const Approve_EMPLOYEE_DOCUMENTS="/systems/management/document"

export const POST_EMPLOYEE_EDUCATION="/systems/management/education"
export const GET_EMPLOYEE_EDUCATION="/systems/management/education"
export const PUT_EMPLOYEE_EDUCATION="/systems/management/education"
export const DELETE_EMPLOYEE_EDUCATION="/systems/management/education"



export const POST_EMPLOYEE_SKILLS="/systems/management/skills"
export const GET_EMPLOYEE_SKILLS="/systems/management/skills"
export const PUT_EMPLOYEE_SKILLS="/systems/management/skills"
export const DELETE_EMPLOYEE_SKILLS="/systems/management/skills"


export const POST_EMPLOYEE_EXPERIENCE="/systems/management/experience"
export const GET_EMPLOYEE_EXPERIENCE="/systems/management/experience"
export const PUT_EMPLOYEE_EXPERIENCE="/systems/management/experience"
export const DELETE_EMPLOYEE_EXPERIENCE="/systems/management/experience"

export const GET_EMPLOYEE_BANK_DETAILS="/systems/management/bank"
export const POST_EMPLOYEE_BANK_DETAILS="/systems/management/bank"
export const PUT_EMPLOYEE_BANK_DETAILS="/systems/management/bank"
export const DELETE_EMPLOYEE_BANK_DETAILS="/systems/management/bank"
export const APPROVED_EMPLOYEE_BANK_DETAILS="/systems/management/bank"


export const GET_EMPLOYEE_BASIC_INFO="/systems/management/get-employee-basic-info"
export const PUT_EMPLOYEE_BASIC_INFO="/systems/management/put-employee-basic-info"
export const GET_DEPARTMENT_DROPDOWN="/systems/department/get-department-dropdown-list"
export const GET_DESIGNATION_DROPDOWN="/systems/designation/get-designation-dropdown-list"
export const GET_EMPLOYEE_ADDRESS_INFO="/systems/management/get-employee-address-info"
export const PUT_EMPLOYEE_ADDRESS_INFO="/systems/management/put-employee-address-info"
export const PUT_EMPLOYEE_PICTURE="/systems/management/upload-employee-picture"
export const GET_EMPLOYEE_PICTURE="/systems/management/get-employee-picture"
export const DELETE_EMPLOYEE_PROFILE_PICTURE="/systems/management/delete-employee-profile-picture"

// -------------- timesheet management -----------------

// Project Management
export const CREATE_PROJECT="/timesheet/project/create-project"
export const UPDATE_PROJECT="/timesheet/project/update-project"
export const DELETE_PROJECT="/timesheet/project/delete-project"
export const GET_ALL_PROJECTS="/timesheet/project/get-all-projects"
export const GET_PROJECT_DROPDOWN="/timesheet/project/get-project-dropdown"

// Timesheet Entries
export const CREATE_TIMESHEET_ENTRY="/timesheet/create-entry"
export const UPDATE_TIMESHEET_ENTRY="/timesheet/update-entry"
export const DELETE_TIMESHEET_ENTRY="/timesheet/delete-entry"
export const SUBMIT_TIMESHEET_ENTRIES="/timesheet/submit-entries"
export const GET_MY_TIMESHEET_ENTRIES="/timesheet/get-my-entries"
export const GET_ALL_TIMESHEET_ENTRIES="/timesheet/get-all-entries"
export const APPROVE_TIMESHEET_ENTRY="/timesheet/approve-entry"
export const REJECT_TIMESHEET_ENTRY="/timesheet/reject-entry"
export const GET_TIMESHEET_SUMMARY="/timesheet/get-timesheet-summary"
export const GET_TIMESHEET_DETAIL_REPORT="/timesheet/get-detail-report"
export const GET_CLIENT_TIMESHEET_VIEW="/timesheet/client-view"
export const CLIENT_APPROVE_ENTRY="/timesheet/client-approve"
export const CLIENT_REJECT_ENTRY="/timesheet/client-reject"

// Employee roster
export const EMPLOYEE_ROSTER_SUMMARY="/dashboard/admin/get-employee-roster-summary"
export const EMPLOYEE_PRESENCE="/dashboard/admin/get-employee-presence"
export const BULK_CHANGE_DEPARTMENT="/systems/employee/bulk-change-department"
export const BULK_ASSIGN_ROLE="/systems/employee/bulk-assign-role"
export const BULK_DEACTIVATE="/systems/employee/bulk-deactivate"
export const BULK_ACTIVATE="/systems/employee/bulk-activate"

// Attendance APIs
export const ATTENDANCE_STAT_COUNTS="/dashboard/admin/get-attendance-stat-counts"
export const EMPLOYEE_PRESENCE_BY_DATE="/dashboard/admin/get-employee-presence-by-date"

// Analytics endpoints
export const ATTENDANCE_ANALYTICS="/dashboard/admin/get-attendance-analytics"
export const LEAVE_ANALYTICS="/dashboard/admin/get-leave-analytics"
export const TIMESHEET_ANALYTICS="/dashboard/admin/get-timesheet-analytics"
export const PRODUCTIVITY_ANALYTICS="/dashboard/admin/get-productivity-analytics"
export const WORKFORCE_ANALYTICS="/dashboard/admin/get-workforce-analytics"